import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  category: [],
  makes: [],
  models: [],
};

export const homepageTabSlice = createSlice({
  name: "hoempageTabs",
  initialState: initialWorkersState,
  reducers: {
    categoryList: (state, action) => {
      const category = action.payload;

      state.category = category;
    },
    makesList: (state, action) => {
      const makes = action.payload;

      state.makes = makes;
    },
    modelsList: (state, action) => {
      const models = action.payload;

      state.models = models;
    },
  },
});
